module.exports = __webpack_public_path__ + "img/succ.88229a87.png";